module.exports = __webpack_public_path__ + "static/media/evening.20338175.svg";